<nz-modal [nzVisible]="visible" [nzWidth]="400" [nzFooter]="null" [nzClosable]="false" [nzMaskClosable]="false" [nzKeyboard]="false" [nzCentered]="true" nzClassName="order-dialog call-link-dialog">
  <ng-container *nzModalContent>
    <div *ngIf="view as v" class="order-dialog__panel" role="alertdialog" aria-labelledby="call-link-title">
      <div class="order-dialog__head">
        <span class="order-dialog__icon call-link__icon" aria-hidden="true">
          <app-order-live-icon name="phone" [size]="20"></app-order-live-icon>
        </span>
        <div class="order-dialog__titles">
          <h2 id="call-link-title" class="order-dialog__title">{{ 'callLink.dialogTitle' | transloco: { num: v.orderNumber } }}</h2>
        </div>
      </div>

      <div class="order-dialog__body order-dialog__body--text">
        <span>{{ 'callLink.dialogText' | transloco: { phone: v.phone, done: (v.doneKey | transloco) } }}</span>
      </div>

      <div class="order-dialog__foot">
        <button type="button" class="order-dialog__btn" (click)="answer(false)">{{ 'callLink.skip' | transloco }}</button>
        <button type="button" class="order-dialog__btn order-dialog__btn--primary" (click)="answer(true)">{{ 'callLink.link' | transloco }}</button>
      </div>
    </div>
  </ng-container>
</nz-modal>
